export default "__VITE_ASSET__zs$bMFVe__"